import React, { memo } from 'react';
import { StyledLabel } from './styled';
export const CheckboxLabel = /*#__PURE__*/memo(_ref => {
  let {
    className,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledLabel, props);
});